import React, {memo} from "react";
import BaseModalSmall from "../BaseModalSmall";
import {Button, Col, Form, Modal, Row} from "react-bootstrap";
import {useDispatch, useSelector} from "react-redux";
import {
    actionChangeHandelModalAddPGratuity,
    actionChangeInputsModalAddGratuity
} from "../../../../../redux/actions/modals/modalGratuity/modalGratuity";
import {actionChangeSelectableQuestion} from "../../../../../redux/actions/modals/modalShoppingCard";

import {
    actionChangeGratuityModalEditOrderDescGratuity
} from "../../../../../redux/actions/modals/editOrder/modalEditDescGratuity";

const ModalGratuity = () => {
    const dispatch = useDispatch();
    const {statusShow, price} = useSelector(state => state.modalGratuity);

    if(statusShow)
        console.log("pas chera neshoon nmide?");

    const handelChangeInputs = (event) => {
        const {name, value} = event.target;
        dispatch(actionChangeInputsModalAddGratuity(name, value));
    };

    const handleClose = () => {
        dispatch(actionChangeHandelModalAddPGratuity(false));
    };

    const handelOk = () => {
        dispatch(actionChangeSelectableQuestion({question:'reward',answerId:4,answerTitle:price}));

        dispatch(actionChangeGratuityModalEditOrderDescGratuity(price)); // in baraye bakhshe virayeshe sefaresh ezafe shode

        handleClose();
    };

    return (
        <BaseModalSmall title={'انعام دلخواه'}
                        show={statusShow}
                        dialogClassName={'cm-modal-gratuity'}
                        handleClose={handleClose}>
            <Modal.Body>
                <Form onSubmit={handelOk}>

                    <Form.Group controlId="input-form-add-price">
                        <Form.Label>
                            لطفا مبلغ را به تومان وارد کنید
                        </Form.Label>
                        <Form.Control type="number" name={'price'} className={'text-center'}
                                      value={price} onChange={handelChangeInputs}
                                      placeholder="مبلغ انعام"/>
                    </Form.Group>
                </Form>
            </Modal.Body>
            <Modal.Footer>
                <Row className={'w-100'}>
                    <Col xs={12}>
                        <Button variant="success" className={'base-btn-green btn-sm'} onClick={handelOk} block>
                            تایید
                        </Button>
                    </Col>
                </Row>
            </Modal.Footer>
        </BaseModalSmall>
    );
};

export default memo(ModalGratuity);
